
















































































import mixins from 'vue-typed-mixins';
import SmartTableBaseMixin from '@/mixins/SmartTable/SmartTableBaseMixin';
import { Column } from '@/models/SmartTable/Column';
import LanguageMixin from '@/mixins/SmartTable/LanguageMixin';
import { dateTimeValueFromInputEvent as dateTimeValueFromInputEventInternal } from '@/models/SmartTable/DateTimeInput';

export default mixins(SmartTableBaseMixin, LanguageMixin).extend({
  props: {
    value: {
      type: Object,
      required: true
    },
    formId: { type: String, default: 'smartTableForm' },
    showColumnDescription: { type: Boolean, default: false }
  },
  data: function () {
    return {
      model: this.value
    };
  },
  watch: {
    value: {
      handler: function (value) {
        this.visibleColumns.forEach((column: Column) => {
          if (column.defaultValue !== undefined && value[column.fieldName] === undefined) {
            value[column.fieldName] = column.defaultValue;
          }
        });
        this.model = value;
      },
      deep: true
    }
  },
  computed: {
    visibleColumns: function (): Column[] {
      return this.config.columns
        ? this.config.columns.filter((c) => c.hiddenInAddDialog === false)
        : [];
    }
  },
  methods: {
    validateAndUpdate: function () {
      if (this.validate() === true) {
        // add default values of hidden columns
        if (this.config.columns) {
          const columns = this.config.columns.filter(
            (c) => c.hiddenInAddDialog === true && c.defaultValue !== undefined
          );
          columns.forEach((column: Column) => {
            this.model[column.fieldName] = column.defaultValue;
          });
        }

        this.$emit('input', this.model);
        return true;
      }
      return false;
    },
    validate: function () {
      let valid = true;
      this.visibleColumns.forEach((column: Column) => {
        const formElement = this.$refs[this.formId + column.fieldName] as HTMLFormElement[];
        if (formElement && formElement.length > 0) {
          const validationResult = column.validate(this.model[column.fieldName], this.model, true);
          if (!validationResult.isValid) {
            let validationMessage = validationResult.errorMessages.join('\n');
            if ((validationMessage.trim() || '').length == 0 && this.currentTranslation) {
              validationMessage = this.currentTranslation.invalidValue;
            }
            formElement[0].setCustomValidity(validationMessage);
            valid = false;
          } else {
            formElement[0].setCustomValidity('');
          }
          formElement[0].reportValidity();
        }
      });
      const formValid =
        this.validateFormOrElement(this.$refs.smartTableForm as HTMLFormElement) === true;
      return valid && formValid;
    },
    dateTimeValueFromInputEvent(inputEvent: Event): string | null {
      return dateTimeValueFromInputEventInternal(inputEvent);
    }
  }
});
